<template>
  <div v-if="result && result.id">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card class="text-center" style="font-size:1.3em">
          <b-row>
            <b-col md="12">
              <h1> {{result.fqdn}} </h1>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Total Pages <br><small>(Page + External + Resource)</small> </label><br>
                <label for="ph_page">{{result.page_count + result.ext_count + result.resource_count }} Numbers</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Inspection time</label>
                <b-badge variant="primary">
                  Total : {{moment(result.finished_at).diff(result.started_at, 'minutes') == 0 ? "< 1" : moment(result.finished_at).diff(result.started_at, 'minutes')}} min
                </b-badge>
                <p>{{result.started_at | utcdatetime}} ~ {{result.finished_at | utcdatetime}}</p>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_detect_count" v-b-tooltip.hover>Detect Pages</label><br>
                <b-badge variant="danger" v-if="result.detect_count > 0"> {{result.detect_count}} Numbers </b-badge>
                <span v-else>-</span>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Status</label><br>
                <b-badge v-if="result.finished_at" :variant="result.finished_at ? 'info' : 'light'"> {{result.finished_at ? 'Finished' : 'Scanning'}} </b-badge>
                <b-badge v-if="result.error_count > 0" variant="warning"> {{result.error_count ? 'Error' : 'Scanning'}} </b-badge>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="6" class="animated fadeIn fadeOut">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>ScreenShot</label><br>
                <img class="border" :src="image" :style="{ width: thumbnail_size }">
              </b-form-group>
            </b-col>
            <b-col md="6" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>Site Configuration Summary</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options" :series="data"></vue-apex-charts>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Page List</strong>
            <small>List of Pages {{result.page_count || 0 | number}} Numbers ({{result.page.start+(result.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.page_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('page')" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>External Page</strong>
            <small>List of external site visits {{result.ext_count | number}} Number ({{result.ext.start+(result.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.ext_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('ext')" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Resource Data</strong>
            <small>Resource Data List {{result.resource_count | number}} Numbers ({{result.resource.start+(result.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.resource_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('resource')" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Detect List</strong> <small>Detect Pattern List {{result.detect_count | number}} Numbers ({{result.detect.start+(result.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.detect_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('detect')" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- 향후 고려 -->
    <!-- <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Error List</strong> <small>Error List {{result.error_count | number}} Numbers ({{result.error.start+(result.error_count ? 1: 0)}} ~ {{result.error.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.error_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('error')" ref="error_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.error.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
import { Api } from '@/service';
import moment from 'moment-timezone'

export default {
  props: ['item', 'result_id'],
  components: { VueApexCharts },
  watch : {
    result_id() {
      this.get()
    }
  },
  data : () => {
    return {
      moment,
      thumbnail_size: '100%',
      data: [],
      options: {
        labels: [],
        legend: { position: 'bottom', }
      },
      result : {
        page : { data: '', start: 0, end: 0 },
        ext: { data: '', start: 0, end: 0 },
        detect: { data: '', start: 0, end: 0 },
        resource: { data: '', start: 0, end: 0 },
        error: { data: '', start: 0, end: 0 }
      },
    }
  },

  computed: {
    page_set() {
      let rv = [];
      _.forEach(this.result.page_data, l => _.forEach(l, r => rv.push(r)))
      return rv;
    },
    page_sub() { return _.groupBy(this.page_set, r => r[2]); },
    page_list() {
      let rv = [];
      let roots = _.filter(this.page_set, p => p[0] == 0);
      let subs = this.page_sub;
      let parser = r => r && `${r[8]} -- [${r[5]}, ${r[6] || '-'}, ${r[7]} bytes]` || '-';
      const builder = (r) => {
        let rv = [_.padStart('', r[0] * 2) + parser(r)];
        _.forEach(subs[r[1]], s => rv = rv.concat(builder(s))); // r[1] == this
        return rv;
      }
      _.forEach(roots, r => rv = rv.concat(builder(r)));

      if(!rv.length) {
        let mains = this.page_set;
        rv = _.map(mains, r => { return [_.padStart('', r[0] * 2) + parser(r)] });
      }
      return rv;
    },
    image() { return this.result.thumbnail && 'data:image/png;base64,' + this.result.thumbnail || 'img/no-image.png'; },
    ext_set() { return this.result.external_data || []; },
    resource_list() {
      let rv = [];
      _.forEach(this.result.resource_data || [], l => _.forEach(l, r => rv.push(r)));
      return rv;
    },
    ext_str() {
      // ver 1.0.1
      let rv = '';
      let parser = r => r && ` -- ${r[8]}\n` || ' -\n';
      _.forEach(this.ext_set, l => rv += (l[2] + parser(this.find_page(l[1]))));
      return rv;
    },
    ext_list() {
      let rv = [];
      _.forEach(this.ext_set, l => _.forEach(l, r => rv.push(r)));
      return rv;
    },
    detect_list() {
      let rv = [];
      _.forEach(this.result.detect_data || [], l => _.forEach(l, r => rv.push(`URL - ${r[6]} / Code (${r[2] || r[3]} ${r[5]} ${r[4]})`)));
      return rv;
    },
  },
  methods: {
    scroll(target='page') {
      // console.log(target, "target")
      let div = this.$refs[target+"_list"];
      if(this.result[target].end >= this.result[target+"_count"]) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this[target+'_list'], this.result[target].end, this.result[target].end + 500);
      console.log('slice', add.length, this.result[target].end, this.result[target].end + 500);
      this.result[target].end += add.length;
      this.result[target].data += '\n' + _.join(add, '\n');
    },
    find_page(k) { return _.find(this.page_set, r => r[1] == k); },
    build() {
      try {
        let page = _.slice(this.page_list, 0, 500);
        let ext = _.slice(this.ext_list, 0, 500);
        let resource = _.slice(this.resource_list, 0, 500);
        let detect = _.slice(this.detect_list, 0, 500);
        this.result.page.data = _.join(page, '\n');
        this.result.page.end = page.length;
        this.result.ext.data = _.join(ext, '\n');
        this.result.ext.end = ext.length;
        this.result.detect.data = _.join(detect, '\n');
        this.result.detect.end = detect.length;
        this.result.resource.data = _.join(resource, '\n');
        this.result.resource.end = resource.length;
      } catch (e) { console.error(e) }
    },
    get() {
      try {
        if(!(this.item && this.item.id)) {
          this.options.labels = []
          this.data = []
          // request to result data
          let so = { target : 'wmds.result', cmd : 'detail', body : { id : this.result_id } }
          Api.Manager(so)
            .then(rs => {
              this.result = Object.assign({}, this.item, this.result, rs.body ? rs.body : {});
              this.build()
              let total = 0
              Object.keys(this.result).forEach(x => {
                try {
                  if(x.endsWith("_count")) {
                    this.data.push(this.result[x])
                    this.options.labels.push(x.replace("_count", ''))
                    total += this.result[x]
                  }
                } catch (e) { console.error(e) }
              })
              this.$toastr.i("Successful load")
              if(total < 1) {
                this.data.push(100)
                this.options.labels.push('inspection failed')
              }
            })
            .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
        } else { this.result = this.item }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
  },
  // watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}
</script>
